import { render, staticRenderFns } from "./TableWarning.vue?vue&type=template&id=5de3ac58&"
import script from "./TableWarning.vue?vue&type=script&lang=js&"
export * from "./TableWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports